module.exports = __webpack_public_path__ + "static/media/Nettoken template.69235f68.csv";